export { SoftwareRovoStartPageTemplate } from "./software-rovo-start-page.template";
export { SoftwareRovoStartPageTemplate as default } from "./software-rovo-start-page.template";
